<ng-container *ngIf="!operator.hasRule() && operator.name === null" i18n>Unnamed composite rule</ng-container>
<ng-container *ngIf="operator.hasRule() && operator.name === null" i18n>Unnamed rule</ng-container>
<ng-container *ngIf="operator.name !== null">{{ operator.name }}</ng-container>
